import { Command as CommandPrimitive } from "cmdk";
import * as React from "react";

import { faSearch } from "@performyard/fontawesome/pro-regular-svg-icons";

import { Option } from "../../../../../types/Option";

import { COMBOBOX_SEARCH_THRESHOLD } from "../../../../../lib/styles";

import { Icon } from "../../../../atoms/Icon";

type SelectSearchHeaderProps<T> = {
	options: Option<T>[];
	fetchOptions?: (searchTerm: string) => Promise<Option<T>[]>;
	searchValue: string;
	onSearchChange: (value: string) => void;
	searchInputRef: React.RefObject<HTMLInputElement | null>;
	onKeyDown?: (e: React.KeyboardEvent) => void;
	parentRef?: React.RefObject<HTMLDivElement | null>;
};

export const SelectSearchHeader = <T,>({
	options,
	fetchOptions,
	searchValue,
	onSearchChange,
	searchInputRef,
	onKeyDown,
	parentRef,
}: SelectSearchHeaderProps<T>) => {
	if (options.length <= COMBOBOX_SEARCH_THRESHOLD && !fetchOptions) {
		return null;
	}

	const handleSearchKeyDown = (e: React.KeyboardEvent) => {
		if (e.key === "ArrowDown" || e.key === "ArrowUp") {
			e.preventDefault();
			e.stopPropagation();
			if (parentRef?.current) {
				parentRef.current.focus();
				onKeyDown?.(e);
			}
		} else if (e.key === "Escape") {
			e.stopPropagation();
		}
	};

	return (
		<div className="flex shrink-0 items-center gap-2 border-b border-solid border-neutral-3 px-3 py-2">
			<Icon icon={faSearch} size={16} color="neutral-5" />
			<CommandPrimitive.Input
				ref={searchInputRef}
				placeholder="Search options..."
				className="w-full border-none bg-transparent text-paragraph-3 outline-none placeholder:text-neutral-5 focus:outline-none"
				value={searchValue}
				onValueChange={onSearchChange}
				onKeyDown={handleSearchKeyDown}
			/>
		</div>
	);
};
